<div class="wrapper" [ngClass]="{ 'is-desktop': !isMobile }">
  <ng-container *ngIf="isLoggedIn && isMobile">
    <app-submit-a-deal-button
      [wrapper]="submitDealWrapper"
    ></app-submit-a-deal-button>
    <ng-template #submitDealWrapper let-text let-handleClick="handleClick">
      <div class="my-3">
        <app-shared-button (click)="handleClick()" theme="secondary">
          {{ text }}
        </app-shared-button>
      </div>
    </ng-template>
  </ng-container>

  <div class="home-header-title" [ngClass]="{ disabled }">
    <h2>Property Listings</h2>
    <span *ngIf="isExternalOrg">
      Showing
      {{
        (orgPropertiesLoading$ | async)
          ? '...'
          : (orgPropertiesCount$ | async) || 0
      }}
      properties
    </span>
    <span *ngIf="!isExternalOrg">
      Showing
      {{ (loading$ | async) ? '...' : count }}
      properties
    </span>
  </div>

  <!-- Showing N properties is being displayed instead -->
  <!-- 
  <div *ngIf="!!(orgUrlSlug$ | async)" class="showing-number">
    We found
    {{
      (orgPropertiesLoading$ | async)
        ? '...'
        : (orgPropertiesCount$ | async) || 0
    }}
    properties with your filters
  </div>

  <div *ngIf="!(orgUrlSlug$ | async)" class="showing-number">
    We found {{ (loading$ | async) ? '...' : (count$ | async) || 0 }} properties
    with your filters
  </div> -->
</div>
